import { attempt } from "@omni/utils/function.utils";

import ContentBlock from "./contentListBlock.component";

type Props = {
    content: string;
};

const ContentListBlock = ({ content }: Props) => (
    <ContentBlock content={attempt(() => JSON.parse(content), {})} />
);

export { ContentListBlock };
